import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Stack,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { searchPayments } from '../api/payment';
import { attachDetachCoupon, getPromotionCode } from '../api/coupon';

const MemberPlanSearch = () => {
  const [memberId, setMemberId] = useState('');
  const [planId, setPlanId] = useState('');
  const [linkageIdentifier, setLinkageIdentifier] = useState('');
  const [results, setResults] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const prevStatuses = useRef({});

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();   
      handleSearch();       
    }
  };

  const handleSearch = async () => {
    setErrorMessage('');
  

    if (!memberId.trim() && !linkageIdentifier.trim()) {
      setErrorMessage('会員IDまたは決済番号を入力してください');
      setResults([]);
      return;
    }

    try {
      const result = await searchPayments(memberId, planId, linkageIdentifier);
      setResults(result);
      const map = {};
      result.forEach((r) => (map[r.linkage_identifier] = r.coupon_status));
      prevStatuses.current = map;
    } catch (error) {
      console.error('検索エラー:', error);
    }
  };

  const handleCreateCoupon = () => {
    navigate('/coupon-register');
  };

  const handleAttachDetachCoupon = async (couponCode, linkage_identifier, coupon_status) => {
    try {
      const coupon_code = couponCode;
      const res = await getPromotionCode(couponCode);
      const promotion_code = res.promotion_code;
      await attachDetachCoupon(promotion_code, linkage_identifier, coupon_code);

      // results の該当行だけ更新
      setResults((prevResults) =>
        prevResults.map((row) =>
          row.linkage_identifier === linkage_identifier
            ? { ...row, coupon_status: coupon_status === 1 ? 0 : 1 }
            : row
        )
      );
    } catch (error) {
      console.error('クーポン操作エラー:', error);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 6 }}>
      <Box
  sx={{
    display: "flex",
    justifyContent: "flex-end", // 右寄せ
    mb: 2
  }}
>
  <Button
    variant="contained"
    color="success"
    sx={{
      borderRadius: "8px"   
    }}
    onClick={handleCreateCoupon}
    
  >
    クーポン新規作成
  </Button>
</Box>
      <Box
        sx={{
          p: 4,
          borderRadius: 2,
          border: '2px solid #333',
          backgroundColor: '#fff',
        }}
      >
        <Typography
  variant="h5"
  component="h2"
  className="search-title"
  sx={{
    borderBottom: "2px solid #32c86b",
    paddingBottom: "4px",
    marginBottom: "20px",
    fontWeight: 700
  }}
>
  会員検索
</Typography>

        <Stack direction="row" spacing={2}>
          {!linkageIdentifier.trim() && (
            <TextField
              label="会員ID"
              variant="outlined"
              value={memberId}
              onChange={(e) => setMemberId(e.target.value)}
              onKeyDown={handleKeyDown}
            fullWidth
          />
          )}
          {!linkageIdentifier.trim() && (
            <TextField
              label="プランID"
              variant="outlined"
              value={planId}
              onChange={(e) => setPlanId(e.target.value)}
              onKeyDown={handleKeyDown}
            fullWidth
          />
          )}
          {!memberId.trim() && (
            <TextField
              label="決済番号"
              variant="outlined"
              value={linkageIdentifier}
              onChange={(e) => setLinkageIdentifier(e.target.value)}
              onKeyDown={handleKeyDown}
            fullWidth
          />
          )}
          <Button
            variant="contained"
            color="primary"
            onClick={handleSearch}
            sx={{
              borderRadius: "8px"   
            }}
            className="search-button"
          >
            検索
          </Button>
        </Stack>

        {errorMessage && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="error">
              {errorMessage}
            </Typography>
          </Box>
        )}
      </Box>

      {/* 検索結果テーブル */}
      {results.length > 0 && (
        <Box sx={{ mt: 4, width: "100%" }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            検索結果
          </Typography>
          <TableContainer 
          component={Paper}
          sx={{
            width: "100%",      
            maxWidth: "100%",
          }}
          >
            <Table>
              <TableHead>
                <TableRow>
                <TableCell sx={{ width: "220px" }}>会員ID</TableCell>
                <TableCell sx={{ width: "180px" }}>プランID</TableCell>
                <TableCell sx={{ width: "300px" }}>決済番号</TableCell>
                <TableCell sx={{ width: "200px" }} />
                </TableRow>
              </TableHead>
              <TableBody>
                {results.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell sx={{ width: "250px", wordBreak: "break-all" }}>
                      {row.member_id}
                    </TableCell>

                    <TableCell sx={{ width: "250px", wordBreak: "break-all" }}>
                      {row.price_id}
                    </TableCell>

                    <TableCell sx={{ width: "250px", wordBreak: "break-all" }}>
                      {row.linkage_identifier}
                    </TableCell>

                    <TableCell align="right" sx={{ width: "200px" }}>
                    <Button
                      variant="outlined"
                      color={row.coupon_status === 1 ? "error" : "primary"}
                      onClick={() =>
                        handleAttachDetachCoupon(
                          row.coupon_code,
                          row.linkage_identifier,
                          row.coupon_status
                        )
                      }
                      sx={{
                        borderRadius: "10px",      
                        paddingX: 3,                
                        paddingY: 1,                
                        textTransform: "none",      
                        fontWeight: 600,            
                        color:"success"
                      }}
                    >
                      {row.coupon_status === 1 ? "クーポンを外す" : "クーポンをつける"}
                    </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      {/* 該当なしメッセージ */}
      {results.length === 0 && (
        <Typography variant="body2" sx={{ mt: 4, textAlign: 'center', color: 'gray' }}>
          該当するデータはありません
        </Typography>
      )}
    </Container>
  );
};

export default MemberPlanSearch;
